// Canonical compensation-method IDs emitted by the CSV ingest lambda's
// `deriveFacets` (`packages/lambdas/src/sqs/advisors-csv-ingest/facets.ts`).
// These IDs match what is stored in `RiaFirm.compensationMethods` in Postgres.
export const FEE_OPTION_KEYS = [
  'aum',
  'hourly',
  'subscription',
  'flatFee',
  'commission',
  'performance',
  'other',
] as const;

export type FeeOptionKey = (typeof FEE_OPTION_KEYS)[number];

export const FEE_OPTIONS: readonly { key: FeeOptionKey; label: string }[] = [
  { key: 'aum', label: '% of AUM' },
  { key: 'hourly', label: 'Hourly' },
  { key: 'subscription', label: 'Subscription' },
  { key: 'flatFee', label: 'Flat / Fixed Fee' },
  { key: 'commission', label: 'Commission' },
  { key: 'performance', label: 'Performance-Based' },
  { key: 'other', label: 'Other' },
];
